export default __webpack_public_path__ + "static/amdocs-1359197c0c98745f58ce0a95ac7e4aaf.png";